import type { App } from 'vue'
import { install } from 'vue3-recaptcha-v2'

import env from '@/app/env'

export default {
  install: (app: App) => {
    app.use(install, {
      sitekey: env.recaptchaKey,
      cnDomains: false,
    })
  },
}
